import _ from "lodash";
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData } from "./persisterService";
import { DataLeakPersonalAffection } from "../../types/DataLeakPersonalAffection";
import { persistContractClaimSubEntities } from "./AbstractContractClaimPersister";
import { UseForm } from "../../types/UseForm";
import { DataLeakContract } from "../../types/Products/ContractLaw/DataLeakContract";

export const persistDataLeakContract = async (updateData: UseForm["values"], origContractCase: DataLeakContract) => {
  await persistContractClaimSubEntities(updateData, origContractCase);

  if (_.isObject(updateData.personalAffection)) {
    const personalAffectionUpdateData = getUpdateData(
      updateData.personalAffection,
      origContractCase,
      "personalAffection"
    );

    await persistDataLeakPersonalAffection(origContractCase.personalAffection.id, personalAffectionUpdateData);
  }

  const apiUri = getProductData(origContractCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origContractCase);
  await apiPatch(apiUri, origContractCase.id, contractCaseUpdateData);
};

const persistDataLeakPersonalAffection = async (
  id: number,
  personalAffectionUpdateData: Partial<DataLeakPersonalAffection>
) => {
  return await apiPatch("data_leak_personal_affections", id, personalAffectionUpdateData);
};
